import { defineStore, acceptHMRUpdate } from "pinia";
import { store } from "@/store";
import { login,getOrgInfo } from "@/api/system/index";
import router from "@/router";

export const useAccountStore = defineStore("account", {
  // a function that returns a fresh state
  state: () => ({
    token: sessionStorage.getItem("token"),
    workspace_id: localStorage.getItem("Workspace_id"),
    user_id: localStorage.getItem("uuid"),
  }),
  // optional getters
  getters: {},
  // optional actions
  actions: {
    /**
     * 登录
     * @param data
     * @param {Object} payload userName {String} 用户账号
     * @param {Object} payload password {String} 密码
     */
    async login(data: any) {
      // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
      // token 代表用户当前登录状态 建议在网络请求中携带 token
      // 整个系统依赖这两个数据进行校验和存储
      const userInfo = await login(data);
      console.log(userInfo)
      sessionStorage.setItem("token", userInfo.accessToken);
      localStorage.setItem("uuid", userInfo.userId);
      localStorage.setItem("Workspace_id", userInfo.workspaceId);
      localStorage.setItem("orgid",userInfo.orgIds)
      const userdetails = await getOrgInfo({});
      console.log(userdetails)
      if(userdetails.list[0].cityCode){
        localStorage.setItem("cityCode", userdetails.list[0].cityCode);
      }
      if(userdetails.list[0].areaCode){
        localStorage.setItem("areaCode",userdetails.list[0].areaCode)
      }
      if (userdetails.list[0].areaCode) {
        localStorage.setItem("provinceCode", userdetails.list[0].id)
      }
      if(userdetails.list[0].lng){
        localStorage.setItem("lng", userdetails.list[0].lng);
        localStorage.setItem("lat", userdetails.list[0].lat);
      }
      if(userdetails.list[0].alt){
        localStorage.setItem("alt", userdetails.list[0].alt);
      }
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */

    logout({ confirm = false } = {}) {
      return new Promise((resolve, reject) => {
        /**
         * @description 注销
         */
        sessionStorage.clear();
        localStorage.clear();
        // 跳转路由
        router.push({ name: "Login" });
        resolve(true);
      });
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAccountStore, import.meta.hot));
}
